import { rgb } from '../helpers';
import { BLACK, DARK_BLUE, SKY_BLUE, WHITE } from '../theme/color';

export const overrides = {
    MuiCheckbox: {
        root: {
            borderColor: `rgba(${rgb(BLACK)}, 0.2)`,
            boxShadow: `inset 0 2px 0 0 rgba(${rgb(SKY_BLUE)}, 0.12)`,
            backgroundColor: WHITE,

            '& .NeptuneCheckbox-checkedIcon path': {
                fill: DARK_BLUE
            }
        }
    }
};
